type FileReaderMethods = 'readAsArrayBuffer' | 'readAsDataURL';

/**
 * Promisified version of selected FileReader API methods.
 */
function promisedFileReader<T extends string | ArrayBuffer>(
  method: FileReaderMethods,
): (blob: File | Blob) => Promise<T> {
  return (blob: File | Blob) =>
    new Promise<T>(function (resolve, reject) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result as T);
      };
      fileReader.onerror = () => {
        reject(new Error('Failed to read file'));
      };
      fileReader[method](blob);
    });
}

export function readAsArrayBuffer(file: Blob | File): Promise<ArrayBuffer> {
  return promisedFileReader<ArrayBuffer>('readAsArrayBuffer')(file);
}
export function readAsDataUrl(file: Blob | File): Promise<string> {
  return promisedFileReader<string>('readAsDataURL')(file);
}
